import React from 'react'

function ContContact() {
  return (
    <section className="cont__contact">
        <p>Let’s create something new</p>
        <h3>LET`S Get IN<em>TOUCH</em></h3>
        <a href="/">contact me</a>
    </section>
  )
}

export default ContContact